(function () {
  angular
    .module('specsguardApp')
    .controller('TemplateListCtrl', TemplateListCtrl);

  TemplateListCtrl.$inject = ['$scope', '$stateParams', '$location', 'templates', 'PvETemplateAPI', '$mdDialog',
    'BuildingTemplateAPI', 'errorMessageService', '$document', 'Labels'];

  function TemplateListCtrl ($scope, $stateParams, $location, templates, PvETemplateAPI, $mdDialog,
    BuildingTemplateAPI, errorMessageService, $document, Labels) {
    $scope.labels = Labels;
    $scope.projectLevelKey = $stateParams.projectLevel === 1 ? 'projecttemplate' : 'buildingtemplate';
    $scope.projectLevel = $stateParams.projectLevel === 1 ?
      $scope.labels.getLabel('projecttemplate') : $scope.labels.getLabel('buildingtemplate');
    $scope.projectLevels = $stateParams.projectLevel === 1 ?
      $scope.labels.getPlural('projecttemplate') : $scope.labels.getPlural('buildingtemplate');
    $scope.templates = templates;
    const API = $stateParams.projectLevel === 1 ? PvETemplateAPI : BuildingTemplateAPI;
    const reqKey = $stateParams.projectLevel === 1 ? 'pvetemplate' : 'buildingtemplate';

    $scope.update = function (data) {
      const index = $scope.templates.findIndex(function (template) {
        return template._id === data._id;
      });

      if (index > -1) {
        $scope.templates[index] = data;
      } else {
        $scope.templates.push(data);
      }
    };

    $scope.openTemplate = function (templateId) {
      $location.path(($stateParams.projectLevel === 1 ? '/pve_template/' : '/building_template/') + templateId);
    };

    $scope.removeTemplate = function (index) {
      const confirmDelete = $mdDialog.confirm()
        .title($scope.labels.getPlural('areyousuredeletingtemplate'))
        .ariaLabel($scope.labels.getPlural('areyousuredeletingtemplate'))
        .ok($scope.labels.getPlural('delete'))
        .cancel($scope.labels.getLabel('cancel'));

      $mdDialog.show(confirmDelete).then(
        function () {
          API.delete({ id: $scope.templates[index]._id }).$promise.then(function () {
            errorMessageService.showSuccess($scope.labels.getLabel('deletedtemplate'));
            $scope.templates.splice(index, 1);
          });
        }, () => {});
    };

    $scope.open = function (ev, template, type) {
      $scope.originalTemplate = template || undefined; // used in template_dialog
      $scope.template = Object.assign({}, template);
      if (type === 'copy') {
        $scope.template.name += ' ' + $scope.labels.getLabelLowerCase('copy2');
      }

      $scope.type = type;

      $mdDialog.show({
        controller: 'TemplateDialogCtrl',
        templateUrl: 'app-legacy/components/sg-template-list/template_dialog/template_dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true,
      })
        .then(function () {
          APIActions[$scope.type]().$promise.then((data) => {
            errorMessageService.showSuccess(APIActions[$scope.type + 'Message']);
            $scope.update(data);
          });
        }, function () {});
    };

    const APIActions = {
      create: () => API.save({ [reqKey]: { name: $scope.template.name } }),
      createMessage: $scope.projectLevel + ' ' + $scope.labels.getLabel('succesfully') + ' ' +
      $scope.labels.getLabel('created'),
      copy: () => API.copy({ id: $scope.template._id },
        { [reqKey]: { name: $scope.template.name } }),
      copyMessage: $scope.projectLevel + ' ' + $scope.labels.getLabel('succesfully') + ' ' +
      $scope.labels.getLabel('copied'),
    };
  }
})();
